/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_External_Booking_Edit_Extras_Disabled_For_ResourceInputs */

const en_admin_external_booking_edit_extras_disabled_for_resource = /** @type {(inputs: Admin_External_Booking_Edit_Extras_Disabled_For_ResourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Some extras are not available for the selected resource and have been disabled.`)
};

const de_admin_external_booking_edit_extras_disabled_for_resource = /** @type {(inputs: Admin_External_Booking_Edit_Extras_Disabled_For_ResourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einige Extras sind für die ausgewählte Ressource nicht verfügbar und wurden deaktiviert.`)
};

const es_admin_external_booking_edit_extras_disabled_for_resource = /** @type {(inputs: Admin_External_Booking_Edit_Extras_Disabled_For_ResourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Algunos extras no están disponibles para el recurso seleccionado y se han desactivado.`)
};

const fr_admin_external_booking_edit_extras_disabled_for_resource = /** @type {(inputs: Admin_External_Booking_Edit_Extras_Disabled_For_ResourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Certains extras ne sont pas disponibles pour la ressource sélectionnée et ont été désactivés.`)
};

const nl_admin_external_booking_edit_extras_disabled_for_resource = /** @type {(inputs: Admin_External_Booking_Edit_Extras_Disabled_For_ResourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sommige extras zijn niet beschikbaar voor de geselecteerde voorziening en zijn uitgeschakeld.`)
};

/** @type {(inputs: Admin_External_Booking_Edit_Extras_Disabled_For_ResourceInputs) => LocalizedString} */
const it_admin_external_booking_edit_extras_disabled_for_resource = en_admin_external_booking_edit_extras_disabled_for_resource;

/** @type {(inputs: Admin_External_Booking_Edit_Extras_Disabled_For_ResourceInputs) => LocalizedString} */
const pt_br2_admin_external_booking_edit_extras_disabled_for_resource = en_admin_external_booking_edit_extras_disabled_for_resource;

/** @type {(inputs: Admin_External_Booking_Edit_Extras_Disabled_For_ResourceInputs) => LocalizedString} */
const pl_admin_external_booking_edit_extras_disabled_for_resource = en_admin_external_booking_edit_extras_disabled_for_resource;

/** @type {(inputs: Admin_External_Booking_Edit_Extras_Disabled_For_ResourceInputs) => LocalizedString} */
const hu_admin_external_booking_edit_extras_disabled_for_resource = en_admin_external_booking_edit_extras_disabled_for_resource;

/** @type {(inputs: Admin_External_Booking_Edit_Extras_Disabled_For_ResourceInputs) => LocalizedString} */
const ro_admin_external_booking_edit_extras_disabled_for_resource = en_admin_external_booking_edit_extras_disabled_for_resource;

/**
* | output |
* | --- |
* | "Some extras are not available for the selected resource and have been disabled." |
*
* @param {Admin_External_Booking_Edit_Extras_Disabled_For_ResourceInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_external_booking_edit_extras_disabled_for_resource = /** @type {((inputs?: Admin_External_Booking_Edit_Extras_Disabled_For_ResourceInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_External_Booking_Edit_Extras_Disabled_For_ResourceInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_external_booking_edit_extras_disabled_for_resource(inputs)
	if (locale === "de") return de_admin_external_booking_edit_extras_disabled_for_resource(inputs)
	if (locale === "es") return es_admin_external_booking_edit_extras_disabled_for_resource(inputs)
	if (locale === "fr") return fr_admin_external_booking_edit_extras_disabled_for_resource(inputs)
	if (locale === "nl") return nl_admin_external_booking_edit_extras_disabled_for_resource(inputs)
	if (locale === "it") return it_admin_external_booking_edit_extras_disabled_for_resource(inputs)
	if (locale === "pt-BR") return pt_br2_admin_external_booking_edit_extras_disabled_for_resource(inputs)
	if (locale === "pl") return pl_admin_external_booking_edit_extras_disabled_for_resource(inputs)
	if (locale === "hu") return hu_admin_external_booking_edit_extras_disabled_for_resource(inputs)
	return ro_admin_external_booking_edit_extras_disabled_for_resource(inputs)
});
export { admin_external_booking_edit_extras_disabled_for_resource as "admin.external_booking_edit.extras_disabled_for_resource" }